import { useState } from 'react';
import { ApplicationSectionFrame } from '../components/application-section-frame';
import { SelectField, TextField, YES_NO_OPTIONS } from '../components/form-fields';
import { useApplication } from '../hooks/use-application';
import type { ConsumerStepProps } from './step-props';

const QUESTIONS: { field: Exclude<keyof ConsumerApplicationHealth, 'conditions'>; label: string }[] = [
  { field: 'tobacco', label: 'Have you used tobacco or nicotine in the last 12 months?' },
  { field: 'dailyActivityHelp', label: 'Do you need help with any daily activities today, like bathing or dressing?' },
  { field: 'memoryDiagnosis', label: 'Have you been diagnosed with memory loss or a cognitive condition?' },
  { field: 'recentHospitalStay', label: 'Any hospital or ER stays in the last 12 months?' },
  { field: 'pendingTests', label: 'Are any medical tests or treatments planned or waiting on results?' },
];

export function ApplicationHealthStep({ clientId }: ConsumerStepProps) {
  const { answers } = useApplication(clientId);
  const [health, setHealth] = useState(answers.health);

  return (
    <ApplicationSectionFrame
      clientId={clientId}
      section="health"
      title="Your health information"
      subtitle="Plain-language questions. Answer what you can."
      draft={{ health }}
    >
      <TextField
        label="Health conditions you’ve been diagnosed with"
        value={health.conditions}
        onChange={conditions => setHealth(current => ({ ...current, conditions }))}
        hint="From your intake. Add anything missing."
        multiline
      />
      {QUESTIONS.map(({ field, label }) => (
        <SelectField
          key={field}
          label={label}
          value={health[field]}
          onChange={value => setHealth(current => ({ ...current, [field]: value }))}
          options={YES_NO_OPTIONS}
        />
      ))}
    </ApplicationSectionFrame>
  );
}
